import { Jurisdiction } from '/@/modules/predefined/models/Jurisdiction';
import { BaseWorkflowRule } from '@/modules/workflow/models/BaseWorkflowRule';

export class WorkflowJurisdictionRule extends BaseWorkflowRule {
  id?: number;

  jurisdictionId?: number;

  jurisdiction?: Relationship<Jurisdiction>;

  constructor(model: Partial<WorkflowJurisdictionRule> = {}) {
    super(model);

    this.id = model.id;
    this.jurisdictionId = model.jurisdictionId;
    this.jurisdiction = Jurisdiction.mapModelOrNull(model.jurisdiction) || undefined;
  }

  get ruleId(): string | undefined {
    return this.jurisdictionId?.toString();
  }

  toString(): string {
    return this.jurisdiction?.name;
  }
}
